import { render, staticRenderFns } from "./ModalItemManagement.vue?vue&type=template&id=55901b25&scoped=true&"
import script from "./ModalItemManagement.vue?vue&type=script&lang=js&"
export * from "./ModalItemManagement.vue?vue&type=script&lang=js&"
import style0 from "./ModalItemManagement.vue?vue&type=style&index=0&id=55901b25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55901b25",
  null
  
)

export default component.exports